import { render, staticRenderFns } from "./InfosetsOverviewItemSkeleton.vue?vue&type=template&id=20c89643&"
import script from "./InfosetsOverviewItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./InfosetsOverviewItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports